import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";

export const LANGS = [
  { code: "en", label: "English", flag: "gb" },
  { code: "de", label: "Deutsch", flag: "de" },
  { code: "es", label: "Español", flag: "es" },
  { code: "fr", label: "Français", flag: "fr" },
  { code: "it", label: "Italiano", flag: "it" },
];

const DICTS = { de, es, fr, it };
const STORAGE_KEY = "rh_lang";
const codes = LANGS.map((l) => l.code);

export const detectLang = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (codes.includes(saved)) return saved;
  const prefs = navigator.languages || [navigator.language];
  for (const p of prefs) {
    const c = (p || "").slice(0, 2).toLowerCase();
    if (codes.includes(c)) return c;
  }
  return "en";
};

let current = detectLang();
document.documentElement.lang = current;

export const getLang = () => current;

export const setLang = (code) => {
  current = code;
  localStorage.setItem(STORAGE_KEY, code);
  document.documentElement.lang = code;
};

const norm = (s) => s.replace(/\s+/g, " ").trim();

export function t(text, vars) {
  if (typeof text !== "string") return text;
  let out = text;
  if (current !== "en") {
    const d = DICTS[current];
    out = d[text] ?? d[norm(text)] ?? text;
  }
  if (vars) out = out.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  return out;
}

const cache = new WeakMap();

export function L(obj) {
  if (obj === null || typeof obj !== "object") return obj;
  if (cache.has(obj)) return cache.get(obj);
  const p = new Proxy(obj, {
    get(target, key, recv) {
      const v = Reflect.get(target, key, recv);
      if (typeof v === "string") return t(v);
      if (v && typeof v === "object") return L(v);
      return v;
    },
  });
  cache.set(obj, p);
  return p;
}

export const localeTag = () => ({ en: "en-GB", de: "de-DE", es: "es-ES", fr: "fr-FR", it: "it-IT" })[current];

export const tr = t;
